import { render, staticRenderFns } from "./CarFireInsuranceReserveDataTable.vue?vue&type=template&id=fd200042&scoped=true"
import script from "./CarFireInsuranceReserveDataTable.vue?vue&type=script&lang=js"
export * from "./CarFireInsuranceReserveDataTable.vue?vue&type=script&lang=js"
import style0 from "./CarFireInsuranceReserveDataTable.vue?vue&type=style&index=0&id=fd200042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd200042",
  null
  
)

export default component.exports